import type {
  UseGetVendorsQuoteParams,
  UseGetVendorsQuoteQueryKey,
} from './types';

export const getUseGetVendorsQuoteQueryKey = (
  params: UseGetVendorsQuoteParams,
): UseGetVendorsQuoteQueryKey => ['vendors', 'vendorsQuote', params];
